import EmailForm from '../../components/Emails/EmailForm';
import { CREATE_EMAIL } from '../../constants';

function EmailCreation() {
  return <EmailForm type={CREATE_EMAIL} />;
}

export default EmailCreation;
